<template>
  <AppSection :unpadded="mobile">
    <AppContainer>
      <h2 v-html="$tt('about_page.operate_title')" />
      <AppThirdLayout>
        <AppImg src="/images/about/globe-icon.jpg" :alt="$tt('about_page.img_globe')" />
        <div class="content flex col justify-between mt-8 mb-6 me-10">
          <p class="lead">
            {{ $tt('about_page.operate_body') }}
          </p>
          <h3 class="mb-3">
            {{ $tt('about_page.global_presence') }}
          </h3>
        </div>
      </AppThirdLayout>

      <DesktopOnly class="cards-container justify-center mt-3 flex gap-7">
        <AboutBranchCard v-for="branch in acknowledgedBranches" :branch />
      </DesktopOnly>
    </AppContainer>

    <MobileOnly>
      <AppContainer end>
        <AppCarousel
          :autoplay="4000"
          pause-autoplay-on-hover wrap-around pagination elevated
        >
          <Slide v-for="branch in acknowledgedBranches" :key="branch">
            <AboutBranchCard :branch />
          </Slide>
        </AppCarousel>
      </AppContainer>
    </MobileOnly>
  </AppSection>
</template>

<script setup lang="ts">
import { Slide } from 'vue3-carousel';
const { acknowledgedBranches } = useBranch();
const { mobile } = useBreakpoints();
</script>

<style scoped lang="scss">
.lead {
  font-size: 20px;
  font-weight: 500;
}
.content {
  .lead {
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  section {
    margin-bottom: var(--space-8);
  }
  .lead {
    font-size: 20px !important;
  }
  h2 {
    margin-bottom: 0 !important;
    text-align: center;
  }
  h3 {
    font-size: 24px;
    margin-top: var(--space-6);
    margin-bottom: calc(-1 * var(--space-6));
  }
  img {
    width: 100%;
    margin: auto;
  }
  .content {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    margin-inline-end: 0 !important;
  }
  .cards-container {
    flex-direction: column;
  }
  :deep(.v-slide-group) {
    margin-inline-start: 0 !important;
  }
}
</style>